import React, {useContext} from 'react';
import {Query} from 'react-apollo';
import {teamQuery} from '../../../data/team-profile/queries';
import {RouteContext} from '../../../shared/enhancers/router-enhancer';
export const TeamProfileContext = React.createContext(false);

// eslint-disable-next-line react/prop-types
const withTeamProfile = Component => ({teamId, currentUser, ...restProps}) => {
  const {slug} = useContext(RouteContext);
  const context = {slug};
  return (
    <Query query={teamQuery} variables={{id: teamId}}>
      {({data: {team}, loading}) => {
        return (
          <TeamProfileContext.Provider value={context}>
            <Component {...restProps} currentUser={currentUser} team={team} loading={loading} />
          </TeamProfileContext.Provider>
        );
      }}
    </Query>
  );
};

export default withTeamProfile;
